import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';
import withWindowResize from './window-resize'
import Drawer from '../../page/components/drawer';
import RadioButton from './radio-button';
import RadioButtonGroup from './radio-button-group';

import './dropdown.less';
const VALUE_DELIMITER = ':-:';



function Dropdown({ options, className, ariaLabel, onChange, value, label, device, color }) {
    const wrapperRef = useRef(null);
    const [ selectIndex, selectOption ] = useState(Math.max(options.findIndex(o => o.value === value),0));
    const [isOpen, setIsOpen] = useState(false);
    const selectedOption = options[selectIndex] || {};

    
    React.useEffect(() => {
        selectOption(Math.max(options.findIndex(o => o.value === value),0));
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    },[value])
    
    /**
     * This should only be listening when the dropdown is open
     */
    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false);
            document.removeEventListener("click", handleClickOutside, false);
        }
    };
    const toggleOpen = () => {
        if(!isOpen){
            document.addEventListener("click", handleClickOutside, false);
        }else{
            document.removeEventListener("click", handleClickOutside, false);
        }
        setIsOpen(!isOpen);
    }
    
    return (
        <div className={`dropdown ${color}${className ? ' '+className:''}`} ref={wrapperRef}>
            <button className={'select'} onClick={toggleOpen} aria-label={ariaLabel || label}>
                {label && <span className='label'>{label}</span>}
                <span className={'selected'}>{selectedOption.label}</span>
                <Icon name={isOpen ? 'up' : 'down'} size={12}/>
            </button>
            {isOpen && device !== 'mobile' && (<div className='option-container' >
                {
                    options.map((o,i) => {
                        const { value } = o;
                        return (<button className={'option'} key={i} onClick={() => {
                            selectOption(i);
                            toggleOpen();
                            onChange && onChange(typeof value !== 'undefined' ? value : i);
                        }}>{o.label}</button>)
                    })
                }
            </div>)}
            {
                device === 'mobile' && <Drawer open={isOpen} onClose={() => {  }} position={'bottom'}>
                    {label && <span className='label'>{label}</span>}
                    <RadioButtonGroup className={'dropdown-drawer'} name={`dropdown-${label}`} onChange={(value) => {
                        const [ optionVal , index ] = value.split(VALUE_DELIMITER);
                        selectOption(index * 1);
                        toggleOpen();
                        onChange && onChange(optionVal);
                    }}>
                    {
                        options.map((o,i) => {
                            return (<RadioButton 
                                    label={o.label} 
                                    value={`${o.value}${VALUE_DELIMITER}${i}`} 
                                    color={'dark'} 
                                    key={o.label}
                                    checked={i === selectIndex}/>)
                        })
                    }
                    </RadioButtonGroup>
                </Drawer>
            }
        </div>
    );
}

Dropdown.propTypes = {
    /** Array of dropdown options, ex: [{ label: 'Options 1',value: 1}] */
    options: PropTypes.array.isRequired,
    /** Set color theme for drop down*/
    color: PropTypes.oneOf(["light","dark"]),

};

Dropdown.defaultProps = {
    color: 'light'
}

Dropdown.whyDidYouRender = true;

export default withWindowResize(React.memo(Dropdown));
